import { render, staticRenderFns } from "./sponsers-list.vue?vue&type=template&id=0da0b9b7&scoped=true&"
import script from "./sponsers-list.vue?vue&type=script&lang=js&"
export * from "./sponsers-list.vue?vue&type=script&lang=js&"
import style0 from "./sponsers-list.vue?vue&type=style&index=0&id=0da0b9b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0b9b7",
  null
  
)

component.options.__file = "sponsers-list.vue"
export default component.exports